import isNil from "lodash/isNil"

export default (value) => isNil(value) ? "-" : value;
